import { Box, Flex } from "@chakra-ui/react";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { useRef, useState } from "react";
import Form from "./Form";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";

const AddLead = () => {
  // Calculate default date and time (current time + 2 hours)
  const currentMoment = moment().tz("Asia/Kolkata");
  const pickupMoment = currentMoment.clone().add(2, "hours");

  const todayDate = pickupMoment.format("DD/MM/YYYY"); // Use pickup moment for date
  const defaultTime = pickupMoment.format("HH:mm");

  const [data, setData] = useState({
    pickupdate: todayDate,
    pickuptime: defaultTime, // Current time + 2 hours
  });
  const formRef = useRef();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = formRef.current;
    const formDataObj = new FormData(form);
    const payload = {};

    // Convert form data to object
    formDataObj.forEach((value, key) => {
      payload[key] = value;
    });

    // tripType comes from state (radio buttons)
    payload.tripType = data?.tripType || "RT";

    // Create query string
    const queryString = new URLSearchParams(payload).toString();

    navigate(`/bookings/lead/results?${queryString}`);
  };

  return (
    <Box px={6} py={8}>
      <BreadCrumbMaker
        items={[
          { link: "/bookings", title: "Bookings" },
          { link: "/bookings/lead/search", title: "Add Booking", on: true },
        ]}
      />

      <Flex
        justifyContent="space-between"
        gap={2}
        flexDir={{ base: "column", md: "row" }}
        minH={"30vh"}
      >
        <Box w={{ base: "100%", md: "100%" }}>
          <Form
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            formRef={formRef}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default AddLead;
